var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.095,
    height: 36.095,
    viewBox: "-516.359 46.95 36.095 36.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-516.36 64.947a18.047 18.047 0 1 1 0 .1z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-513.351 64.947a15.04 15.04 0 1 1 0 .1z",
    fill: "#c7c7c7",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-499.063 72.668h-5.61c-1.484 0-2.157-2.158-1.299-3.683.647-1.15 1.706-2.452 3.43-3.193a6.05 6.05 0 0 0 3.478 1.097c1.293 0 2.49-.407 3.477-1.097 1.725.74 2.785 2.043 3.432 3.193.858 1.525.185 3.683-1.299 3.683h-5.609Zm-4.588-11.81v-1.1a4.588 4.588 0 1 1 9.175 0v1.1a4.587 4.587 0 1 1-9.175 0Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-499.063 72.668h-5.61c-1.484 0-2.157-2.158-1.299-3.683.647-1.15 1.706-2.452 3.43-3.193a6.05 6.05 0 0 0 3.478 1.097c1.293 0 2.49-.407 3.477-1.097 1.725.74 2.785 2.043 3.432 3.193.858 1.525.185 3.683-1.299 3.683h-5.609Zm-4.588-11.81v-1.1a4.588 4.588 0 1 1 9.175 0v1.1a4.587 4.587 0 1 1-9.175 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "rgba(0,0,0,0 )",
    fill: "transparent"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcon);
export default __webpack_public_path__ + "static/media/icon-icon.f1e0be167a452dadf581abc6e7fcf756.svg";
export { ForwardRef as ReactComponent };